import { Box } from '../'
import './ItemPill.scss'

const colorClasses = ['white', 'pink', 'blue', 'red', 'baby-blue', 'yellow']

export const ItemPill = ({ index, action, empty, alt = 'grey', blackListBackgrounds = [], onClick, selected, children }) => {
  const colorClassesAllowed = colorClasses.filter(color => !blackListBackgrounds.includes(color))

  return <Box
    className={`item-pill ${empty ? 'empty' : action ? 'action' : index !== undefined ? colorClassesAllowed[index % colorClassesAllowed.length] : alt}
    ${selected ? ' selected' : ''}${onClick ? ' selectable' : ''}${(index === undefined && !action) ? ('-' + alt) : ''}`}
    fullWidth
    container
    radius={60}
    onClick={onClick}
    cursor={onClick && 'pointer'}
  >
    {children}
  </Box>
}
